import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { cloneDeep } from 'lodash-es';
import * as moment from 'moment';
import { Observable, Subscription } from 'rxjs';
import { Dictionary, DictionaryType } from '../../../../domain/dictionary.model';
import { ValidationError } from '../../../../domain/error.model';
import { FrontierRequest } from '../../../../domain/frontier.domain';
import { VehicleDefinitionMode } from '../../../../domain/product.domain';
import { ErrorAwareComponent, LsnErrorStateMatcher } from '../../../shared/middleware/error-state-matcher';
import { DictionaryState } from '../../store/dictionary.state';
import { ErrorsState } from '../../store/errors.state';
import { FrontierAction } from '../../store/frontier.action';
import { FrontierState } from '../../store/frontier.state';

@Component({
    selector: 'app-new-frontier',
    templateUrl: './frontier-form.component.html'
})
export class NewFrontierComponent implements OnInit, OnDestroy, ErrorAwareComponent {

    @Select(DictionaryState.getDictionaries) dictionaries$: Observable<{ [key: string]: Dictionary }>;
    subscriptions: Subscription[] = [];
    errors: ValidationError[] = [];
    request = new FrontierRequest();
    vehicleDefinitionMode = VehicleDefinitionMode;
    matchers = {
        all: new LsnErrorStateMatcher(this, ''),
        contactData: {
            email: new LsnErrorStateMatcher(this, 'contactData.email'),
            phonePrefix: new LsnErrorStateMatcher(this, 'contactData.phonePrefix'),
            phoneNumber: new LsnErrorStateMatcher(this, 'contactData.phoneNumber'),
        },
        location: new LsnErrorStateMatcher(this, 'location'),
        insurancePeriod: new LsnErrorStateMatcher(this, 'insurancePeriod'),
        insuranceStartDate: new LsnErrorStateMatcher(this, 'insuranceStartDate'),
        paymentType: new LsnErrorStateMatcher(this, 'paymentType'),
        vehicleDefinition: {
            licensePlate: new LsnErrorStateMatcher(this, 'vehicleDefinition.licensePlate'),
            vin: new LsnErrorStateMatcher(this, 'vehicleDefinition.vin'),
        },
        vehicleOriginCountry: new LsnErrorStateMatcher(this, 'vehicleOriginCountry'),

    };
    dictionaryTypes = DictionaryType;

    todayPlus30 = moment().add(30, 'day').startOf('day').toDate();

    constructor(private store: Store,
    ) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(ErrorsState.getMainErrors).subscribe(errors => this.errors = errors),
            this.store.select(FrontierState.getRequest).subscribe(request => this.request = cloneDeep(request)),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    submit(): void {
        this.store.dispatch(new FrontierAction.Create(this.request));
    }
}
